import { useGetInfo } from '@frx/frx-react-context';
import { useMemo } from 'react';
import { decode } from 'html-entities';
import { useLowercaseQueryString } from './useLowercaseQueryString';
import { useAppProvider } from '../context';

const safeJSONParse = (str: string) => {
  if (!str) return;
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error('Invalid JSON string:', e);
    return null;
  }
};

export const useFormOwner = () => {
  const {
    queryStrings: { fr_id, proxy_id: PROXY_ID, proxy_type: PROXY_TYPE },
  } = useLowercaseQueryString();
  const {
    data: { token },
  } = useAppProvider();

  const setTag = () => {
    switch (PROXY_TYPE) {
      case '22':
        return `[[S43:${fr_id}:name:${PROXY_ID}]]`;
      case '20':
        return `[[?xx::x[[S48:${fr_id}-${PROXY_ID}:screenname]]x::[[S48:${fr_id}-${PROXY_ID}:cons.first_name]] [[S48:${fr_id}-${PROXY_ID}:cons.last_name]]::[[S48:${fr_id}-${PROXY_ID}:screenname]]]]`;
      default:
        return `[[S42:${fr_id}:title]]`;
    }
  };

  const setUrl = () => {
    const domain = 'https://[[S29:DOMAIN]][[S29:SECURE_PATH]]TR';
    switch (PROXY_TYPE) {
      case '22':
        return `${domain}?pg=team&team_id=${PROXY_ID}&fr_id=${fr_id}`;
      case '20':
        return `${domain}?pg=individual&px=${PROXY_ID}&fr_id=${fr_id}`;
      default:
        return `${domain}?pg=entry&fr_id=${fr_id}`;
    }
  };

  const content = { owner: setTag(), url: setUrl() };
  const {
    data: getTagInfoResponse,
    isLoading,
    isSuccess,
  } = useGetInfo({ content, auth: token }, 'formOwnerTag', {
    enabled: !!token,
  });

  const value = useMemo(() => {
    const decodedString = decode((getTagInfoResponse || {})?.preview);
    const escapedString = decodedString.replace(
      /:(\s*)"(.*?)"(\s*[},])/g,
      (match, before, val, after) => {
        const fixedValue = val.replace(/(?<!\\)"/g, '\\"');
        return `:${before}"${fixedValue}"${after}`;
      }
    );

    const tagInfoData = safeJSONParse(escapedString);
    const formOwner = tagInfoData?.owner;
    const formOwnerUrl = tagInfoData?.url;

    return { formOwner, formOwnerUrl };
  }, [getTagInfoResponse]);

  return {
    data: value,
    isError: false,
    isLoading,
    isSuccess,
  };
};
